import { ATTENDANCE_FILTERS } from "constants";
import { PERMISSIONS } from "utils/permissions";

export const DASHBOARD_CARDS = [
  {
    name: "total_users",
    text: "All",
    filterBy: ATTENDANCE_FILTERS.all,
    iconColor: "info",
    iconComponent: "group",
  },
  {
    name: "total_checked_in_office",
    text: "Checked In (Office)",
    filterBy: ATTENDANCE_FILTERS.checked_in_office,
    iconColor: "success",
    iconComponent: "login",
  },
  {
    name: "total_checked_in_wfh",
    text: "Checked In (WFH)",
    filterBy: ATTENDANCE_FILTERS.checked_in_wfh,
    iconColor: "primary",
    iconComponent: "home_work",
  },
  {
    name: "total_on_break",
    text: "On break",
    filterBy: ATTENDANCE_FILTERS.on_break,
    iconColor: "warning",
    iconComponent: "cookie",
  },
  {
    name: "total_checked_out",
    text: "Checked Out",
    filterBy: ATTENDANCE_FILTERS.checked_out,
    iconColor: "dark",
    iconComponent: "logout",
  },
  {
    name: "total_absent",
    text: "Absent",
    filterBy: ATTENDANCE_FILTERS.absent,
    iconColor: "error",
    iconComponent: "event_busy",
  },
];

export const REPORT_TABS = [
  {
    name: "generalReport",
    text: "General Report",
    path: "/reports/general-report",
    permission: PERMISSIONS.REPORTS_GENERAL,
    iconColor: "info",
    iconComponent: "report",
  },
  {
    name: "leaveAndWFHReport",
    text: "Leave And WFH Report",
    path: "/reports/leave-and-wfh-report",
    permission: PERMISSIONS.REPORTS_LEAVE_WFH,
    iconColor: "primary",
    iconComponent: "summarize",
  },
  {
    name: "travelAllowanceReport",
    text: "Travel Allowance Report",
    path: "/reports/travel-allowance-report",
    permission: PERMISSIONS.REPORTS_TRAVEL_ALLOWANCE,
    iconColor: "success",
    iconComponent: "directions_car",
  },
  {
    name: "unapprovedAbsenceReport",
    text: "Unapproved Absence Report",
    path: "/reports/unapproved-absence-report",
    permission: PERMISSIONS.REPORTS_UNAPPROVED_ABSENCE,
    iconColor: "error",
    iconComponent: "event_busy",
  },
  {
    name: "unresolvedComments",
    text: "Unresolved Comments",
    path: "/reports/unresolved-comments",
    permission: PERMISSIONS.REPORTS_UNRESOLVED_COMMENTS,
    iconColor: "warning",
    iconComponent: "comment",
  },
];

export const TRAVEL_ALLOWANCE_ELIGIBILITY_FILTER_OPTIONS = [
  { value: "all", label: "All" },
  { value: "hide_zero", label: "Eligible Only" },
  { value: "only_zero", label: "Ineligible Only" },
];

export const TRAVEL_ALLOWANCE_TABLE_COLUMNS = [
  { key: "officeOnlyDays", label: "Office-only Days" },
  { key: "wfhOnlyDays", label: "WFH-only Days" },
  { key: "hybridDays", label: "Hybrid Days" },
  { key: "totalOfficeHours", label: "Total Office Hours" },
  { key: "eligibleDays", label: "Eligible Days", sortable: true },
  {
    key: "litresEarned",
    label: "Litres Earned",
    tooltip: "Eligible Days × 1.5L per day",
  },
];

export const USER_REPORT_CARDS = [
  {
    name: "total_hours",
    text: "Total Hours",
    iconColor: "info",
    iconComponent: "alarm_clock",
  },
  {
    name: "total_attendance_hours",
    text: "Total Attendance",
    iconColor: "success",
    iconComponent: "login",
  },
  {
    name: "office_duration_hours",
    text: "Office Duration",
    iconColor: "primary",
    iconComponent: "work",
  },
  {
    name: "breaks_duration",
    text: "Break Duration",
    iconColor: "warning",
    iconComponent: "cookie",
  },
  {
    name: "wfh_duration_hours",
    text: "Work From Home Duration",
    iconColor: "dark",
    iconComponent: "home",
  },
];

export const REPORT_SUMMARY_CARDS = [
  {
    name: "averageDailyWorkingHours",
    text: "Avg. Daily Working Hours",
    iconColor: "info",
    iconComponent: "alarm_clock",
  },
  {
    name: "averageWorkingHoursFromHome",
    text: "Avg. Working Hours From Home",
    iconColor: "primary",
    iconComponent: "home",
  },
  {
    name: "averageWorkingHoursFromOffice",
    text: "Avg. Working Hours (Office)",
    iconColor: "success",
    iconComponent: "work",
  },
  {
    name: "weeklyHoursSpent",
    text: "Weekly Hours Spent",
    iconColor: "dark",
    iconComponent: "schedule",
  },
];

export const THEME_COLORS = {
  primary: "#18C1E8",
  secondary: "#9825B9",
  secondary_light: "#DADADA40",
  black: "#000000",
  white: "#ffffff",
};

export const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// Shared filter-bar styling so every report tab has the same row of 35px controls
export const REPORT_TOOLBAR_SX = { rowGap: 1.5, columnGap: 2 };

export const REPORT_BUTTON_SX = {
  whiteSpace: "nowrap",
  height: "35px",
  minHeight: "35px",
  borderRadius: "0.5rem",
};

export const reportFieldSx = {
  cursor: "pointer",
  "& .MuiInputBase-root": {
    minHeight: "15px",
    height: "35px !important",
    padding: "0 12px !important",
    borderRadius: "0.5rem !important",
    fontSize: "12px !important",
    border: "none",
    boxShadow: "none",
    cursor: "pointer",
  },
  "& .MuiInputBase-input": {
    height: "100% !important",
    fontSize: "12px",
    cursor: "pointer",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": { border: "none" },
  },
};

export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    fontSize: 12,
    minHeight: "15px",
    height: "35px",
    textAlign: "left",
    borderRadius: "0.5rem",
    border: "none",
    boxShadow: "none",
    cursor: "pointer",
  }),
  valueContainer: (provided) => ({
    ...provided,
    cursor: "pointer",
  }),
  input: (provided) => ({
    ...provided,
    cursor: "pointer",
  }),
  placeholder: (provided) => ({
    ...provided,
    cursor: "pointer",
  }),
  singleValue: (provided) => ({
    ...provided,
    cursor: "pointer",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: THEME_COLORS.black,
  }),
  menu: (base) => ({ ...base, zIndex: 9 }),
  option: (provided, state) => {
    const selectedOptionColor = THEME_COLORS.white;
    const selectedOptionBackgroundColor = THEME_COLORS.primary;
    const selectedOptionColorLight = THEME_COLORS.black;
    const selectedOptionBackgroundColorLight = THEME_COLORS.secondary_light;
    return {
      ...provided,
      height: 35,
      fontSize: 12,
      color: state.isSelected && selectedOptionColor,
      backgroundColor: state.isSelected && selectedOptionBackgroundColor,
      "&:hover": {
        color: state.isSelected ? selectedOptionColor : selectedOptionColorLight,
        backgroundColor: state.isSelected
          ? selectedOptionBackgroundColor
          : selectedOptionBackgroundColorLight,
      },
      "&:focus": {
        color: state.isSelected ? selectedOptionColor : selectedOptionColorLight,
        backgroundColor: state.isSelected
          ? selectedOptionBackgroundColor
          : selectedOptionBackgroundColorLight,
      },
      "&:active": {
        color: state.isSelected ? selectedOptionColor : selectedOptionColorLight,
        backgroundColor: state.isSelected
          ? selectedOptionBackgroundColor
          : selectedOptionBackgroundColorLight,
      },
    };
  },
};
